export class I18N {
	static localeAliases = {
		'de': 'de-DE',
		'de-DE': 'de-DE',
		'en': 'en-US',
		'en-US': 'en-US',
	}
	static userLang = navigator.language ? I18N.localeAliases[navigator.language] : false || navigator.userLanguage ? I18N.userLanguage[navigator.language] : false

	static translations = {
		'de-DE': {
			'yes': 'ja',
			'no': 'nein',
			'About Us': 'Über uns',
			'Login': 'Anmelden',
			'Logout': 'Abmelden',
			'Account': 'Anmeldedaten',
			'Counter': 'Theke',
			'Refresh': 'Aktualisieren',
			'Entry': 'Eingang',
			'Preparation start': 'Zubereitung ab',
			'Date': 'Termin',
			'Name': 'Name',
			'Fon': 'Tel.',
			'Store': 'Store',
			'Price': 'Preis',
			'Payment': 'Zahlung',
			'Delivery': 'Lieferung',
			'Complete': 'Erledigen',
			'The automatic update will continue...': 'Die Aktualisierung ist unterbrochen, wird aber gleich fortgesetzt...',
			'Auto updates resumed.': 'Aktualisierungen wieder aktiv.',
			'The task could not be completed due to technical reasons.': 'Aus technischen Gründen konnte die Aufgabe nicht abgeschlossen werden.',
			'now': 'jetzt',
			'You are not authorized for any store. Please contact the administrator at support@viertel-lieferservice.de to receive authorizations.': 'Du bist für keinen Store berechtigt. Bitte melde dich beim Administrator unter support@viertel-lieferservice.de um Brechtigungen zu erhalten.',
			'Close ': '<span class="material-icons">close</span>',
			'cook': 'Koch',
			'rider': 'Fahrer',
			'User Info': 'Benutzerinfo',
			'eMail': 'E-Mail',
			'Roles': 'Rollen',
			'Groups': 'Gruppen',
			'Items': 'Artikel',
			'Reject': 'Abweisen',
			'PICKUP': 'Abholerrabatt',
			'CAMPAIGN': 'Rabattaktion',
			'FREE_LONG_DISTANCE_DELIVERY': 'Freie Langstreckenlieferung',
			'DELIVERY': 'Liefergebühr',
			'FREE_DELIVERY': 'Freie Lieferung',
			'MISSING_TO_MIN_VALUE': 'Aufschlag zum Mindestbestellwert',
			'Preparation time': 'Zubereitungszeit',
			'Print': 'Drucken',
			'Receipt printing': 'Belegdruck',
			'Print receipt': 'Beleg automatisch drucken',
			'Cancelled': 'Storniert',
			'Reason for rejection': 'Ablehnungsgrund',
			'Current overload': 'Aktuelle Überlastung',
			'Multiple products unavailable': 'Mehrere Produkte nicht verfügbar',
			'Shop unexpectedly closed': 'Shop unplanmäßig geschlossen',
			'Other reason (please specify)': 'Sonstiges (bitte angeben)',
			'Confirm': 'Bestätigen',
			'Cash': 'Bar',
			'Failed to save payment type': 'Zahlungsart konnte nicht gespeichert werden.',
			'For dialog-free printing and an order alarm that also works while the screen is locked, install the Windows companion app.': 'Für dialogloses Drucken und einen Bestellalarm, der auch bei gesperrtem Bildschirm funktioniert: Windows-Begleitagenten installieren.',
			'Download': 'Herunterladen',
			'Security certificate': 'Sicherheitszertifikat',
			'If Windows warns about the installer, install this certificate first (double-click it, then "Install Certificate" → Local Machine → store: Trusted People):': 'Falls Windows beim Installer warnt: zuerst dieses Zertifikat installieren (Doppelklick, dann „Zertifikat installieren" → Lokaler Computer → Speicher: Vertrauenswürdige Personen):',
			'If the installer is blocked, use this portable version instead: unzip it and run ViertelLieferserviceAgent.exe directly.': 'Falls der Installer blockiert wird, stattdessen diese portable Version nutzen: entpacken und ViertelLieferserviceAgent.exe direkt starten.',
			'Portable version': 'Portable Version',
			'Windows companion app': 'Windows-Begleitagent',
			'Show download hint in the counter': 'Download-Hinweis im Counter anzeigen',
			'Also shown while the companion app is running, e.g. to download an update or the portable version.': 'Wird auch angezeigt, wenn der Begleitagent bereits läuft – z. B. um ein Update oder die portable Version herunterzuladen.'
		}
	}

	static translatePage = () => {
		document.querySelectorAll('*[i18n]:not([i18n=translated]):not([i18n=unknown])').forEach(element => {
			const input = element.innerHTML
			const translation = I18N._translate(input)
			if (translation === undefined) {
				console.debug(`No translation to ${I18N.userLang} for "${input}" at ${I18N._getDomPath(element)}`)
				element.setAttribute('i18n', 'unknown')
			}
			else if (translation) {
				element.innerHTML = translation
				element.setAttribute('i18n', 'translated')
			}
		})
	}

	static translateElement = element => {
		element.querySelectorAll('*[i18n]:not([i18n=translated]):not([i18n=unknown])').forEach(element => {
			const input = element.innerHTML
			const translation = I18N._translate(input)
			if (translation === undefined) {
				console.debug(`No translation to ${I18N.userLang} for "${input}" at ${I18N._getDomPath(element)}`)
				element.setAttribute('i18n', 'unknown')
			}
			else if (translation) {
				element.innerHTML = translation
				element.setAttribute('i18n', 'translated')
			}
		})
	}

	static translate = input => {
		const translation = this._translate(input)
		if (translation) {
			return translation
		}
		else {
			console.debug(`No translation to ${I18N.userLang} for "${input}"`)
		}
		return input
	}

	static _translate = input => {
		if (input) {
			const langRessources = I18N.translations[I18N.userLang]
			if (!langRessources) {
				console.warn(`No translations for ${I18N.userLang}!`)
				return null
			}
			const translation = I18N.translations[I18N.userLang][input]
			if (!translation) {
				return undefined // No translation for this string
			}
			return translation
		}
		else {
			return null // Empty input
		}
	}

	static translateAndFormat = (template, ...args) => {
		const translatedTemplate = I18N._translate(template)
		if (translatedTemplate === undefined) {
			console.debug(`No translation to ${I18N.userLang} for "${template}"`)
			return I18N.format(template, ...args)
		}
		else if (translatedTemplate) {
			return I18N.format(translatedTemplate, ...args)
		}
		else {
			return template // Unknown language or empty template
		}
	}

	static format = (template, ...args) => {
		return template.replace(/{(\d+)}/g, (match, number) => {
			return typeof args[number] != 'undefined'
				? args[number]
				: match
		})
	}

	static _getDomPath = element => {
		const stack = []
		while (element.parentNode != null) {
			let sibCount = 0
			let sibIndex = 0
			for (var i = 0; i < element.parentNode.childNodes.length; i++) {
				const sib = element.parentNode.childNodes[i]
				if (sib.nodeName === element.nodeName) {
					if (sib === element) {
						sibIndex = sibCount
					}
					sibCount++
				}
			}
			if (element.hasAttribute('id') && element.id !== '') {
				stack.unshift(element.nodeName.toLowerCase() + '#' + element.id)
			} else if (sibCount > 1) {
				stack.unshift(element.nodeName.toLowerCase() + ':eq(' + sibIndex + ')')
			} else {
				stack.unshift(element.nodeName.toLowerCase())
			}
			element = element.parentNode
		}

		return stack.slice(1) // removes the html element
	}
}